import React, { Fragment, useState, useEffect } from "react";
import SideMenu from "../../Components/SideMenu";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "../../Dashboard.css";
import IncomeEstimateClassForm from "./Components/IncomeEstimateClassForm";
import StyledDataGrid from "../../../GeneralComponents/StyledDataGrid";
import CircularIndeterminate from "../../../GeneralComponents/CirularProgress";
import UpdateActivityForm from "../Activities/UpdateActivityForm";
import ViewActivity from "../Activities/ViewActivity";

import "../../../../../assets/css/DG.css";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import Modal from "@mui/material/Modal";
import { useGlobalContext } from "../../../../../context";
import UpdateIncomeEstimateClass from "./UpdateIncomeEstimateClass";
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");

const label = { inputProps: { "aria-label": "توقيع المكلف او وكيله" } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};

function IncomeEstimateClass(props) {
  const [loading, setLoading] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });


  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [activityTotal, setActivityTotal] = useState(0);
  const [activityNumberOfPages, setActivityNumberOfPages] = useState(0);
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const { incomeEstimateClassList, activities, fetchData } = useGlobalContext();

  const [columns] = useState([
    { field: "id", headerName: "ت", flex: 0.1 },
    {
      field: "incomeTaxReport",
      headerName: "المكلف",
      flex: 2,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.income_tax_report?.tax_payer_name}
          </div>
        );
      },
    },
    {
      field: "name",
      headerName: "حالة اللجنة المخمنة",
      flex: 1.2,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.committeewith_carrier?.name}
          </div>
        );
      },
    },
    {
      field: "committee_result",
      headerName: "القيمة المحددة من اللجنة ",
      flex: 1.5,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.committee_result?rows.row.committee_result:"في مرحلة التحديد"}
          </div>
        );
      },
    },
    {
      field: "name1",
      headerName: "اسم النشاط",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.varieties_with_career?.varieties_carrier?.name}</div>;
      },
    },
    {
      field: "amount_for_varieties",
      headerName: "قيمة الصنف",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.varieties_with_career?.amount}
          </div>
        );
      },
    },
    {
      field: "notes",
      headerName: "ملاحظات",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.notes?rows?.row?.notes:'----'}
          </div>
        );
      },
    },

    {
      field: "actions",
      flex: 1,
      headerName: "الادوات",
      renderCell: (rows) => (
        <strong>
         

          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row);
            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

        </strong>
      ),
    },
  ]);

  const [rows, setRow] = useState([]);
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1);
  };

  const updateObject = async (object) => {
    setSelectedObject(object);

    setshowBoxOfEditForm(true);
  };
  const viewObject = async (object) => {
    setSelectedObject(object);
    setshowBoxOfViewForm(true);
  };
  const advanceSearch = () => {
    fetchData("INCMOE_ESTIMATE_CLASS", "income_estimate_class/index", {
      page: pageNumber,
      page_size: pageSize,
    });
  };
  useEffect(() => {
    advanceSearch();
  }, [pageSize, pageNumber]);
  //Reformatting activity object once activity are loaded
  useEffect(() => {
    if (incomeEstimateClassList && incomeEstimateClassList.data && incomeEstimateClassList.data.length > 0) {
      setRow(incomeEstimateClassList.data);
      setActivityTotal(incomeEstimateClassList.total);
      setActivityNumberOfPages(incomeEstimateClassList.last_page);
    }
  }, [incomeEstimateClassList]);





  return (
    <div className="Dashboard_MOF1 px-0 pb-6 mx-0 " style={{overflow: 'hidden'}}>
  
            <div
             
              style={{
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
            >
            
              <IncomeEstimateClassForm object={props?.object}/>
            </div>

            <div
             
              style={{
                height: "calc(100% - 9em)",
                minHeight: 400,
                width:'99%',
                borderRadius: 10,
                height:'450px'
              }}
            >
              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={incomeEstimateClassList?.total ? incomeEstimateClassList?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize);
                }}
                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params);
                }}
              />
              <Box width="45%" m="auto" sx={{ marginTop: "10px" }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={activityNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p);
                  }}
                />
              </Box>

              <div
                style={{
                  width: "50%",
                  position: "absolute",
                  top: "100px",
                  margin: "0 auto",
                  left: "50%",
                  top: "50%",
                }}
              >
                {loading && <CircularIndeterminate />}
              </div>
            </div>
    

          <Modal
            keepMounted
            open={showBoxOfEditForm || showBoxOfViewForm}
            onClose={() => {
              setshowBoxOfEditForm(false);
              setshowBoxOfViewForm(false);
            }}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
          >
            <Box
              sx={style}
              style={{
                border: "none",
                outline: "none",
                borderRadius: "10px",
                overflow: "scroll",
              }}
              className="modalCroupsCarrier"
            >
              {selectedObject && showBoxOfEditForm && (
                <UpdateIncomeEstimateClass object={selectedObject} advanceSearch={advanceSearch} setshowBoxOfEditForm={setshowBoxOfEditForm}/>
              )}
            
            </Box>
          </Modal>
          <br />
          <br />
          <br />
    </div>
  );
}

export default IncomeEstimateClass;
